module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "id": "main-nav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "site-details"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', {
    attrs: {
      "id": "logo"
    }
  }, [_vm._v("Develteam")])])], 1), _vm._v(" "), _c('search-widget'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "logged-in-user-details"
    }
  }, [(!_vm.isLoggedIn && _vm.showUserPanel) ? _c('div', {
    staticClass: "unlogged"
  }, [_c('router-link', {
    staticClass: "log-in",
    attrs: {
      "to": "/Login"
    }
  }, [_vm._v("Log In")]), _vm._v(" "), _c('router-link', {
    staticClass: "sign-up",
    attrs: {
      "to": "/Register"
    }
  }, [_vm._v("Sign Up")])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && _vm.showUserPanel) ? _c('div', {
    staticClass: "logged"
  }, [_c('div', {
    staticClass: "log-out",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logOut($event)
      }
    }
  }, [_vm._v("Log out")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.loggedUserDetails.info,
      "profile-type": "developer",
      "size": "very-small",
      "show-xp-info": true
    }
  })], 1), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.showNotificationsList = !_vm.showNotificationsList
      }
    }
  }, [_c('i', {
    staticClass: "far fa-bell"
  }), _vm._v(" "), (_vm.unreadNotifications > 0) ? _c('div', {
    staticClass: "notification-count"
  }, [_vm._v(_vm._s(_vm.unreadNotifications))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/Invites",
      "tag": "div"
    }
  }, [_c('i', {
    staticClass: "far fa-user"
  }), _vm._v(" "), (_vm.unreadInvitesNotificationCount > 0) ? _c('div', {
    staticClass: "notification-count"
  }, [_vm._v(_vm._s(_vm.unreadInvitesNotificationCount))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/Inbox",
      "tag": "div"
    }
  }, [_c('i', {
    staticClass: "far fa-envelope"
  }), _vm._v(" "), (_vm.unreadInboxCount > 0) ? _c('div', {
    staticClass: "notification-count"
  }, [_vm._v(_vm._s(_vm.unreadInboxCount))]) : _vm._e()]), _vm._v(" "), (_vm.showNotificationsList) ? _c('div', {
    attrs: {
      "id": "notifications-list"
    },
    on: {
      "mouseleave": function($event) {
        _vm.showNotificationsList = false
      }
    }
  }, [(_vm.notificationsFetchingStatus !== 'fetched' && _vm.notifications && _vm.notifications.length == 0) ? _c('loader-small') : _vm._e(), _vm._v(" "), (_vm.notificationsFetchingStatus === 'fetched') ? [(_vm.notifications.length > 0) ? _c('div', {
    staticClass: "notifications"
  }, _vm._l((_vm.notifications), function(notification) {
    return (notification.text && notification.link) ? _c('router-link', {
      class: {
        new: notification.hasBeenRead === 0
      },
      attrs: {
        "to": notification.link
      }
    }, [_c('span', {
      staticClass: "text"
    }, [(!notification.hasBeenRead) ? _c('i', {
      staticClass: "fas fa-bell"
    }) : _vm._e(), _vm._v(" " + _vm._s(notification.text))]), _vm._v(" "), _c('span', {
      staticClass: "time-stamp"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(notification.created)))])]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), (_vm.notifications.length === 0) ? _c('div', {
    staticClass: "notifications"
  }, [_c('span', {
    staticClass: "no-notifications-message"
  }, [_vm._v("You don't have any notifications")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/Notifications"
    }
  }, [_c('span', [_vm._v("View all...")])])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c6a88102!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/MainNav.vue
// module id = 913
// module chunks = 2